module.exports = __webpack_public_path__ + "img/album07_18.ca2fe752.jpg";